<template>
<el-dialog
    title="确认出库"
    :visible.sync="confirmVisible"
    :close-on-click-modal="false"
    width="80%"
    center
    :before-close="closeadd"
  >
  <div class="topForm">
    <div class="top" style="font-size:16px;margin-bottom:10px;margin-left:10px;">
      车号：<span >{{tEmptyOutstockMaster.outstockPlateNumber}}</span>
    </div>
  </div>
  <div style="margin:20px 0 30px 0;" v-for="(item,ix) in allDataList" :key="ix">
          <p>货物信息</p>
          <hr>
          <div>
            <div style="display: flex;justify-content: space-between;">
              <div style="display: flex;margin-bottom:10px;">
                <div>{{(item.cargoControlKey).replace(/,/g,"/")}}</div>
                <div style="display: flex;">
                  <span style="margin-left:20px;">总重量：</span>
                  <div>
                    <span style="color:red">{{item.sumWeight}}</span><span> 吨 </span>
                    <span> / </span><span style="color:red">{{item.num}}</span><span> 件</span>
                  </div>
                </div>
                <div style="display: flex;">
                  <span style="margin-left:20px;" v-if='item.controlWeight == 1||item.controlPiece == 1'>未提量：</span>
                  <div>
                    <span v-if='item.controlWeight == 1'><span style="color:red">{{item.controlStockWeight}}</span><span> 吨</span></span>
                    <span v-if='item.controlPiece == 1'><span> / </span><span  style="color:red">{{item.controlStockNumber}}</span><span> 件</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <el-table
            max-height="300px"
            border
            bordersize="mini"
            size="mini"
            ref="tabref"
            :data="item.list"
            style="width:100%"
            highlight-current-row
            :header-cell-style="{background:'#F5F5F5',color:'black'}"
            :header-cell-class-name="Add"
        >
          <el-table-column type="index" prop="date" width="55" label="序号" align="center"></el-table-column>
          <el-table-column prop="number" align="center" label="件数" width="">
            <template slot-scope="scope1">
                <el-input
                  v-model="scope1.row.number"
                  @blur="changeJianShu(scope1.row,scope1.row.number)"
                  v-number-input.float="0"
                  maxlength="50"
                  placeholder="请输入件数"
                  size="mini"
                ></el-input>
             </template>
          </el-table-column>
          <el-table-column prop="weight" align="center" label="理重（吨）" width="">
            <template slot-scope="scope1">
              <el-input
                v-model="scope1.row.weight"
                v-number-input.float="4"
                maxlength="50"
                placeholder="请输入重量"
                size="mini"
                :disabled="true"
                @blur="weightInput(scope1.row,scope1.row.weight)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="weighingWeight" align="center"  label="过磅净重（吨）" width="150">
            <template slot-scope="scope1">
              <el-input
                v-model="scope1.row.weighingWeight"
                v-number-input.float="4"
                maxlength="50"
                placeholder="请输入过磅净重"
                size="mini"
                @blur="weighingWeight(scope1.row,scope1.row.weighingWeight)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="warehouseId" align="center" label="仓位">
              <template slot-scope="scope1">
                <el-select
                clearable
                  filterable
                  @change="changeCangWei(scope1.row,scope1.row.warehouseId)"
                  v-model="scope1.row.warehouseId"
                  size="mini"
                  placeholder="请选择仓位"
                >
                  <el-option
                    v-for="(item,index) in scope1.row.tEmptyStockWarehouseList"
                    :key="index"
                    :label="item.warehouseName"
                    :value="item.warehouseId"
                  ></el-option>
                </el-select>
              </template>
            </el-table-column>
          <el-table-column prop="stockWarehouseNumber" align="center" label="仓位可提件数" width="150">
            <template slot-scope="scope1">
              <el-input
                :disabled="true"
                v-model="scope1.row.stockWarehouseNumber"
                maxlength="50"
                placeholder="请输入"
                size="mini"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="placeOfOrigin" align="center" label="产地" width=""></el-table-column>
          <el-table-column prop="productTypeName" align="center" label="货物类型" width=""></el-table-column>
          <el-table-column prop="specification" align="center" label="规格" width=""></el-table-column>
          <el-table-column prop="model" align="center" label="材质"  width=""></el-table-column>
          <!-- <el-table-column prop="model" align="center" label="出厂过磅净重(吨)"  width=""></el-table-column> -->
        </el-table>
        </div>
        <div slot="footer" style="text-align:center;margin:15px;">
          <el-button @click="closeadd">取 消</el-button>
          <el-button type="primary" :loading="confirmLoading" @click="confirmClick(1)">确认出库</el-button>
          <el-button type="primary" :loading="confirmLoadingDY" @click="confirmClick(2)">确认出库并打印</el-button>
        </div>
  </el-dialog>
</template>

<script>
import {
  JfgetOutstockInfoJanFaForConfirm, // 查询出库单主表子表所有信息（打印、修改回显、确认出库回显用）
  confirmWhOutstockJanFaChuCang, // 出库计划页面  出仓提单创建的出库计划 确认出库
  JfgetNumberForBillStockWarehouse,
  getGoodControlInfo, // 调用控货接口
  getEmptyBillChuCangWeiTi // 取得出仓提单创建的出库计划 确认出库 货物信息未提量
} from '@/api/wms-stock'
// import { dateFormat1 } from '@/utils/util.js'
export default {
  name: 'xieCheDialog',
  data () {
    return {
      confirmLoading: false,
      selectSijiVisible: false,
      TableIndex: 0,
      hasValidFlag: true,
      emptyBillType: '',
      billNo: '',
      addBtnShow: false,
      allDataList: [],
      noBillId: false,
      plateNumberOption: [],
      tEmptyOutstockMaster: {},
      confirmLoadingDY: false,
      checkFlag: true,
      parentData: {},
      weiTiData: {}
    }
  },
  props: {
    confirmVisible: {
      type: Boolean,
      default: false
    },
    outstockId: {
      type: Number
    },
    deliveryObj: {
      type: Object
    }
  },
  watch: {
    deliveryObj: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val) {
          this.parentData = val
          console.log(this.parentData, 'this.parentData')
          // this.primaryCustomerTaxId = val.primaryCustomerTaxId
          // this.secondaryCustomerTaxId = val.secondaryCustomerTaxId
          // this.billId = val.billId
          // this.organizationId = localStorage.getItem('tenantCode')
        }
      }
    }
  },
  async created () {
    await this.getOutstockInfoJanFa()
  },
  methods: {
    // 小星星
    Add (obj) {
      if (obj.column.property == 'number' || obj.column.property == 'warehouseId') {
        return 'star'
      }
    },
    closeadd () {
      this.$emit('update:confirmVisible', false)
    },
    changeJianShu (row, val) {
      if (val) {
        this.$set(row, 'weight', (row.number / 1 * row.singletonWeight).toFixed(4))
        if (row.flag == '理重') {
          this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
        } else {
          this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(4))
        }
      } else {
        this.$set(row, 'weight', '0.000')
        this.$set(row, 'allWeight', '0.000')
        this.$message.error('发货件数不能为空')
      }
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    weightInput (row, val) {
      if (row.flag == '理重') {
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
      } else {
        this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(4))
      }
      row.weight = Number(val).toFixed(4)
      this.allDataList.forEach((item, index) => {
        this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    // 过磅净重
    weighingWeight (row, val) {
      // weighingWeight（过磅净重（吨）  出库计重方式为磅重的时候必填 ）
      // allWeight（总重量（吨）  必填 出库计重方式为理重的时候=理重（吨）、出库计重方式为磅重的时候=过磅净重（吨））
      row.weighingWeight = Number(row.weighingWeight).toFixed(4)
      console.log(row.weighingWeight, 'row.flag')
      if (row.flag == '理重') {
        this.$set(row, 'allWeight', (row.number / 1 * row.singletonWeight).toFixed(4))
      } else {
        this.$set(row, 'allWeight', (row.weighingWeight / 1).toFixed(4))
      }
      this.allDataList.forEach((item, index) => {
        // this.$set(item, 'num', item.list.reduce((pre, cur) => { return pre / 1 + cur.number / 1 }, 0))
        this.$set(item, 'sumWeight', (item.list.reduce((pre, cur) => { return pre / 1 + cur.allWeight / 1 }, 0)).toFixed(4))
      })
    },
    changeCangWei (row, val) {
      console.log(row)
      row.tEmptyStockWarehouseList.forEach((item, index) => {
        if (val == item.warehouseId) {
          row.singletonWeight = item.singletonWeight
          row.warehouseName = item.warehouseName
          this.$set(row, 'stockWarehouseId', item.stockWarehouseId)
          JfgetNumberForBillStockWarehouse({
            stockWarehouseId: row.stockWarehouseId
          }).then(res => {
             this.$set(row, 'stockWarehouseNumber', res.whAvailableNumber)
              this.$set(row, 'whNumber', res.whNumber)
              this.$set(row, 'whWeight', res.whWeight)
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    },
    // 获取数据
    getOutstockInfoJanFa () {
      JfgetOutstockInfoJanFaForConfirm({
        outstockId: this.outstockId
      }).then(res => {
        this.getData(res)
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    async getData (res) {
      this.tEmptyOutstockMaster = res.tEmptyOutstockMaster
      let tEmptyOutstockSummaryList = res.mapList
      if (tEmptyOutstockSummaryList.length != 0) {
        let mapData = new Map()
        for (const item of tEmptyOutstockSummaryList) {
          let cargoControlKey = item.tEmptyOutstockSummary.cargoControlKey
          item.tEmptyOutstockSummary.flag = item.flag
          let keyArr = cargoControlKey.split(',')
          // console.log(item)
          if (item.flag == '理重') {
            item.tEmptyOutstockSummary.allWeight = item.tEmptyOutstockSummary.weight
          } else {
            item.tEmptyOutstockSummary.allWeight = 0
          }
          if (mapData.has(cargoControlKey)) {
            let dataObj = mapData.get(cargoControlKey)
            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += 0
            }
            dataObj.num = dataObj.num + item.tEmptyOutstockSummary.number
            dataObj.releaseFlag = 0
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            dataObj.list.push(item.tEmptyOutstockSummary)
          } else {
            let params = {
              oneCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主纳税人识别号  必填）
              twoCustomerTaxId: this.tEmptyOutstockMaster.customerTaxId, // （二级货主纳税人识别号  必填）
              organizationId: this.tEmptyOutstockMaster.organizationId, // （仓储租户id  必填）
              goodTypeName: keyArr[0] // （货物类型名称  必填
            }
            let res = await getGoodControlInfo(params)
            let billIdData = {
              billId: this.tEmptyOutstockMaster.billId
            }
            // 获取未提量
            this.weiTiData = await getEmptyBillChuCangWeiTi(billIdData)
            let isEnableObj = res
            console.log(isEnableObj, 'isEnableObj')
            console.log(this.weiTiData, 'this.weiTiData')
            let dataObj = {
              cargoControlKey: cargoControlKey,
              releaseFlag: 0,
              list: [],
              controlStockWeight: this.weiTiData.chuCangWeiTiWeight,
              controlStockNumber: this.weiTiData.chuCangWeiTiNumber,
              controlWeight: isEnableObj.controlWeight,
              controlPiece: isEnableObj.controlPiece,
              strictReminder: isEnableObj.strictReminder,
              isEnable: isEnableObj.isEnable,
              sumWeight: 0
            }
            this.$set(item.tEmptyOutstockSummary, 'tEmptyStockWarehouseList', item.tEmptyStockWarehouseList)
            dataObj.list.push(item.tEmptyOutstockSummary)
            console.log(dataObj, 'dataObj11111')
            if (item.flag == '理重') {
              dataObj.sumWeight += item.tEmptyOutstockSummary.weight
            } else {
              dataObj.sumWeight += 0
            }
            // dataObj.sumWeight = sum
            dataObj.num = item.tEmptyOutstockSummary.number
            mapData.set(cargoControlKey, dataObj)
            console.log(mapData, 'mapDatamapDatamapDatamapData')
          }
        }
        this.allDataList = Array.from(mapData.values())
        console.log(this.allDataList, 'this.allDataList')
      } else {
        this.allDataList = []
      }
    },
    recursionCheck (index, type) {
      console.log('asdfasdfads', index)
      if (index < 0) {
        return
      }
      if (index == this.allDataList.length) {
        if (type == 'dayin') {
          console.log('dayin')
          this.confirmWhOutstockB()
        } else {
          this.confirmWhOutstock()
        }
      }
      if (index > this.allDataList.length) {
        // todo
      }
      const item = this.allDataList[index]
      // if (item) {
      if (item.isEnable == '1') {
        // 严控
        if (item.strictReminder == '0') {
          // 控件
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')

              return
            }
          }
          if (item.controlWeight == '1') { // 控吨
            if (item.sumWeight > item.controlStockWeight) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量')
            }
          }
          this.recursionCheck(index + 1, type)
        } else {
          console.log('提示')
          // 提示
          if (item.controlPiece == '1') {
            if (item.num > item.controlStockNumber) {
              this.$message.error((item.cargoControlKey).replace(/,/g, '') + '所输入的件数不能大于未提量')

              return
            }
          }
          // let conFlag = true
          if (item.controlWeight == '1') {
            console.log('控吨')

            if (item.sumWeight > item.controlStockWeight) {
              this.$confirm((item.cargoControlKey).replace(/,/g, '') + '所输入的重量不能大于未提量，是否继续', '提示', {
                confirmButtonText: '继续',
                cancelButtonText: '取消',
                closeOnClickModal: false,
                type: 'warning'
              }).then(() => {
                item.releaseFlag = 1
                console.log(item.cargoControlKey, item.releaseFlag)
                this.recursionCheck(index + 1, type)
              }).catch(() => {
                // this.$message.info('出库操作已取消')
              })
            } else {
              this.recursionCheck(index + 1, type)
            }
          } else {
            this.recursionCheck(index + 1, type)
          }
        }
      } else {
        if (type == 'dayin') {
          console.log('dayin')
          this.confirmWhOutstockB()
        } else {
          this.confirmWhOutstock()
        }
      }
      // }
    },
    confirmClick (n) {
      // strictReminder 严控：0 或提示：1
      for (let i = 0; i < this.allDataList[0].list.length; i++) {
        if (this.allDataList[0].list[i].number / 1 == 0) {
          this.$message({ message: '件数不能为空或0', type: 'error' })
          return
        } else if (this.allDataList[0].list[i].flag == '磅重' && this.allDataList[0].list[i].weighingWeight / 1 == 0) {
          this.$message({ message: '磅重不能为空或0', type: 'error' })
          return
        }
      }
      let controlWeight = this.allDataList[0].controlWeight
      let controlPiece = this.allDataList[0].controlPiece
      let weightBoolean = this.allDataList[0].sumWeight > this.allDataList[0].controlStockWeight
      let numberBoolean = this.allDataList[0].num > this.allDataList[0].controlStockNumber

      if (this.allDataList[0].strictReminder == '0') { // 严控
        if (controlWeight == '1' && controlPiece == '1') {
          if (weightBoolean || numberBoolean) {
            this.$message.error((this.allDataList[0].cargoControlKey).replace(/,/g, '') + '所输入的数据大于出仓单剩余量')
          } else {
            this.confirmWhOutstock(n)
          }
        } else if (controlPiece == '1') { // 控件
          if (numberBoolean) {
            this.$message.error((this.allDataList[0].cargoControlKey).replace(/,/g, '') + '所输入的件数大于出仓单剩余量')
          } else {
            this.confirmWhOutstock(n)
          }
        } else if (controlWeight == '1') { // 控吨
          if (weightBoolean) {
            this.$message.error((this.allDataList[0].cargoControlKey).replace(/,/g, '') + '所输入的重量大于出仓单剩余量')
          } else {
            this.confirmWhOutstock(n)
          }
        }
      } else {
        // 提示
        if (controlWeight == '1' && controlPiece == '1') {
          if (numberBoolean) {
            this.$message.error((this.allDataList[0].cargoControlKey).replace(/,/g, '') + '所输入的件数大于出仓单剩余量')
          } else if (weightBoolean) {
            this.$confirm((this.allDataList[0].cargoControlKey).replace(/,/g, '') + '所输入的吨数大于出仓单剩余量，是否继续', '提示', {
              confirmButtonText: '继续',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.allDataList[0].releaseFlag = 1
              this.confirmWhOutstock(n)
            }).catch(() => {
              // this.$message.info('出库操作已取消')
            })
          } else {
            this.confirmWhOutstock(n)
          }
        } else if (controlPiece == '1') { // 控件 // 产品要求控件必定是严控
          if (numberBoolean) {
            this.$message.error((this.allDataList[0].cargoControlKey).replace(/,/g, '') + '所输入的件数大于出仓单剩余量')
          } else {
            this.confirmWhOutstock(n)
          }
        } else if (controlWeight == '1') { // 控吨
          if (weightBoolean) {
            this.$confirm((this.allDataList[0].cargoControlKey).replace(/,/g, '') + '所输入的重量大于出仓单剩余量，是否继续', '提示', {
              confirmButtonText: '继续',
              cancelButtonText: '取消',
              closeOnClickModal: false,
              type: 'warning'
            }).then(() => {
              this.allDataList[0].releaseFlag = 1
              this.confirmWhOutstock(n)
            }).catch(() => {
              // this.$message.info('出库操作已取消')
            })
          } else {
            this.confirmWhOutstock(n)
          }
        }
      }
    },
    // 调接口
    confirmWhOutstock (n) {
      if (n == '1') {
        this.confirmLoading = true
      } else {
        this.confirmLoadingDY = true
      }
      let obj = {
        tEmptyOutstockMaster: {
          outstockId: this.tEmptyOutstockMaster.outstockId, // （出库单id  必填）
          billId: this.tEmptyOutstockMaster.billId, // （出库提单id  必填）
          primaryCustomerName: this.tEmptyOutstockMaster.primaryCustomerName, // （一级货主名称  必填）
          primaryCustomerTaxId: this.tEmptyOutstockMaster.primaryCustomerTaxId, // （一级货主id  必填）
          customerName: this.tEmptyOutstockMaster.customerName, // （二级货主名称  必填）
          customerTaxId: this.tEmptyOutstockMaster.customerTaxId // （二级货主id 必填）
        },
        queryList: this.allDataList
      }
      confirmWhOutstockJanFaChuCang(obj).then(res => {
        if (n == '1') {
          this.confirmLoading = false
          this.$emit('update:confirmVisible', false)
          this.$message.success('成功')
          this.$parent.chaxun()
        } else {
          this.confirmLoadingDY = false
          this.$emit('update:confirmVisible', false)
          this.$message.success('成功')
          this.$router.push({
            path: '/chukuDanPrint', // 跳转的路径
            query: {
              // 路由传参时push和query搭配使用 ，作用时传递参数
              id: this.tEmptyOutstockMaster.outstockId
            }
          })
        }
      }).catch(err => {
        if (n == '1') {
          this.confirmLoading = false
        } else {
          this.confirmLoadingDY = false
        }
        this.$message.error(err.message)
        if (err.code == '-200') {
          getEmptyBillChuCangWeiTi({
            billId: this.tEmptyOutstockMaster.billId
          }).then(res => {
            for (let index = 0; index < this.allDataList.length; index++) {
              this.allDataList[index].controlStockWeight = res.chuCangWeiTiWeight
              this.allDataList[index].controlStockNumber = res.chuCangWeiTiNumber
            }
          }).catch(err => {
            this.$message.error(err.message)
          })
        }
      })
    }

  },
  mounted () {
  }
}
</script>

<style lang="less" scoped>
/deep/.el-table th.star div::before{
    content: '*' !important;
    color: red !important;
  }
</style>
